import {handleActions} from 'redux-actions';
import {clearSessionAction} from "../ClearSession/ClearSessionActions";
import {createTransform} from 'redux-persist';
import {saveApiTabSelectionAction} from './ApiTabSelectionParamActions';

//- State
export const initialState = {
   apiTabSelection: "Overview"
};

//- Reducers
export const apiTabSelectionParam = handleActions(
   {
      [saveApiTabSelectionAction]: (
           state,
           action,
       ) => ({
           ...state,
          apiTabSelection: action.payload.data.apiTabSelection
       }),
       [clearSessionAction]: () => initialState
   },
   initialState,
);

export const apiTabSelectionParamTransform = createTransform(
   // transform state on its way to being serialized and persisted.
   inboundState => ({
       apiTabSelection: inboundState.apiTabSelection,
   }),
   // transform state being re-hydrated
   outboundState => ({
        ...initialState,
        apiTabSelection: outboundState.apiTabSelection,

   }),
   // define which reducers this transform gets called for.
   //{whitelist: ['apiTabSelectionParam']},
);
